module.exports = __webpack_public_path__ + "img/bmy_ok.673ae673.png";